import PinIcon from '@atlaskit/icon/core/pin';
import * as React from 'react';

export function SvgPin() {
  return <PinIcon label="" testId="ads-refreshed-icon" />;
}
